export default __webpack_public_path__ + "static/media/Saeed.964a976f.jpg";